var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLatex)?_c('vue-mathjax',{class:'noselect ' + _vm.hasClass ? _vm.hasClass : '',attrs:{"id":"mathjaxx","safe":false,"formula":_vm.innerHtml}}):_c('div',{class:'noselect ' + _vm.hasClass ? _vm.hasClass : '',attrs:{"id":"mathjaxx"},domProps:{"innerHTML":_vm._s(_vm.innerHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }